import { useRef } from "react";
import { FiAlertTriangle } from "react-icons/fi";
import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";

export interface ConfirmDialogProps {
  cancelLabel?: string;
  confirmLabel?: string;
  description: string;
  isLoading?: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
}

export function ConfirmDialog({
  cancelLabel = "Cancel",
  confirmLabel = "Delete",
  description,
  isLoading = false,
  isOpen,
  onCancel,
  onConfirm,
  title,
}: ConfirmDialogProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  return (
    <Dialog
      initialFocusRef={cancelRef}
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
    >
      <div className="flex gap-4 rounded-xl border border-danger/20 bg-danger-subtle p-4">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-danger text-white">
          <FiAlertTriangle aria-hidden="true" />
        </span>
        <p className="text-sm leading-relaxed text-body">{description}</p>
      </div>
      <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <Button onClick={onCancel} ref={cancelRef} variant="secondary">
          {cancelLabel}
        </Button>
        <Button isLoading={isLoading} onClick={onConfirm} variant="danger">
          {confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
}
